import { Locale } from 'modules/i18n';

export default {
  [Locale.en]: {
    conditionInfo:
      'Ankr Automate check  if the function is executable at every block.',
    conditionDescription:
      "Checking will begin upon task creation. Make sure the function isn't set to be executed constantly.",
    executeContract:
      'Execute a contract at a given interval with a set start time.',
    submit: 'Continue',
    startTime: 'Start date and time',
    expressionHelper:
      'Use one of the templates below to schedule your jobs or provide your own cron expression',
    dateLabel: 'Start Date and Time',
    cronExpression: 'Cron expression',
    startImmediately: 'Start immediately',
    executionSchedule: 'Execution schedule:',
    dayLabel: 'Day',
    daysPlaceholder: 'Everyday',
    intervalTypeLabel: 'Interval',
    intervalValueLabel: 'Value',
    intervalTypePlaceholder: 'Interval',
    intervalValuePlaceholder: 'Value',
    invalidCronExpression: 'Invalid cron expression!',
    daysAmount: '{amount} days',
  },
};
